import * as HLF from "html-living-framework";
import { ObstacleType } from "../Data/Obstacles";
import { ProjectileToken } from "../Data/ProjectileToken";
import * as Topics from "../Data/Topics";
import { Boomerang } from "../GameObjects/Obstacles/Boomerang";
import { Fuujin } from "../GameObjects/Obstacles/Fuujin";
import { Obstacle } from "../GameObjects/Obstacles/Obstacle";
import { ParallaxLayer } from "../GameObjects/ParallaxLayer";
import { WorldElement } from "../GameObjects/WorldElement";
import { ElementFactory } from "../Utils/ElementFactory";

export class ObstacleLayer extends ParallaxLayer {
    private _types: ReadonlyArray<ObstacleType>;

    private _subscriptions: any[];

    constructor(pSpeed: number, pTypes: ReadonlyArray<ObstacleType>, pXSpacing: PIXI.Point) {
        super(pSpeed, [], pXSpacing, new PIXI.Point(0), new PIXI.Point(1));
        this._types = pTypes;

        this._subscriptions = new Array<any>();
        this._subscriptions.push(PubSub.subscribe(
            Topics.SPAWN_PROJECTILE,
            this.spawnProjectile.bind(this),
        ));
    }

    public init(pSize: PIXI.Point): void {
        this._size.copy(pSize);
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        for (let i = 0; i < this._subscriptions.length; ++i) {
            PubSub.unsubscribe(this._subscriptions);
        }
        super.destroy(pOptions);
    }

    protected removeOffscreenElements(): void {
        if (this.leftElement instanceof Boomerang || this.leftElement instanceof Fuujin) {
            if (this.leftElement.isReversed && this.leftElement.position.x > this.rightEdge) {
                const removed: WorldElement = this._elements.splice(0, 1)[0];
                removed.cleanup();
                this.removeChild(removed);
            }
        }
        else {
            while (this._elements.length > 0 && (this.leftElement.rightEdge < this.leftEdge ||
                    this.leftElement.markedForRemoval)) {
                const removed: WorldElement = this._elements.splice(0, 1)[0];
                removed.cleanup();
                this.removeChild(removed);
            }
        }
    }

    protected spawnNewElement(): void {
        const obstacle: Obstacle = ElementFactory.instance.makeObstacle(HLF.ArrayUtils.random(this._types as any));
        obstacle.position.x = this.rightEdge;
        this.addChild(obstacle);
        this._elements.push(obstacle);
    }

    protected spawnProjectile(pTopic: string, pData: ProjectileToken): void {
        const projectile: Obstacle = ElementFactory.instance.makeObstacle(pData.type);
        projectile.position.copy(pData.pos);
        this.addChild(projectile);
        this._elements.push(projectile);
    }
}
